import * as React from 'react'
import ChevronDown from 'wix-ui-icons-common/ChevronDown'
import {BACK_BUTTON} from '../../config/data-hooks'
import {EventText} from '../styled-components/event-text'
import * as s from './back.scss'
import {BackProps} from './index'

export const Back = ({onClick, href, t}: BackProps) => (
  <a onClick={onClick} href={href} className={s.root} data-hook={BACK_BUTTON}>
    <ChevronDown size={14} viewBox="8 7 9 10" className={s.icon} />
    <EventText extraClass={s.text}>{t('button.back')}</EventText>
  </a>
)
